
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/test/price-card-ab-test-2026/variant_a/course/[slug]",
      function () {
        return require("private-next-pages/test/price-card-ab-test-2026/variant_a/course/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/test/price-card-ab-test-2026/variant_a/course/[slug]"])
      });
    }
  